module.exports = __webpack_public_path__ + "static/media/bt.0d567c62.webp";